import React from 'react';
import PropTypes from 'prop-types';

const SubmitButton = ({
    children, disabled, isSubmitting, onClick, showChevron
}) => {
    const submittingClass = isSubmitting ? 'button-loading' : '';
    const isDisabled = disabled || isSubmitting;

    return (
        <button
            disabled={isDisabled}
            type="submit"
            className={`submit-button button-mega-cta ${submittingClass}`}
            onClick={onClick}
        >
            {!isSubmitting && (
                <span className="submit-button-content-container">
                    <span className="submit-button-content">{children}</span>
                    {showChevron && <span className="submit-button-icon icon-chevron-right" />}
                </span>
            )}
        </button>
    );
};

SubmitButton.propTypes = {
    children: PropTypes.node.isRequired,
    isSubmitting: PropTypes.bool,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    showChevron: PropTypes.bool
};

SubmitButton.defaultProps = {
    disabled: false,
    onClick: undefined,
    showChevron: true,
    isSubmitting: false
};

export default SubmitButton;
